import React from 'react';
import isEqual from 'lodash/isEqual';

import CodeHeader from './../styled/CodeHeader';
import CodeBacker from './../styled/CodeBacker';

function separateScripts(text) {
  let inline = '';
  const scripts = text.match(/(<script.*src=.*?>.*<\/script>)/gim);
  const remotes = scripts ? scripts.map(script => {
    return script.match(/src=['"](.*)['"]/i)[1];
  }) : [];
  const removedRemotes = text.replace(/(<script.*src=.*?>.*<\/script>)/gim, '');
  const code = removedRemotes.replace(/<script[^>]*>([\s\S]*?)<\/script>/gim, (match, group) => {
    inline += group + '\n';
    return '';
  });
  return { inline, remotes, code };
}

function injectInlineScript(script) {
  const body = document.getElementsByTagName('body')[0];
  const scriptElement = document.createElement('script');
  scriptElement.setAttribute('type', 'text/javascript');
  scriptElement.innerHTML = script;
  body.appendChild(scriptElement);
  body.removeChild(scriptElement);
}

function injectRemoteScript(src) {
  if (document.querySelector(`script[src="${src}"]`)) return;
  const body = document.getElementsByTagName('body')[0];
  const scriptElement = document.createElement('script');
  scriptElement.setAttribute('src', src);
  body.appendChild(scriptElement);
}

class Code extends React.Component {
  componentDidMount() {
    const { inline, remotes } = separateScripts(this.props.code);
    injectInlineScript(inline);
    remotes.forEach(src => injectRemoteScript(src));
  }

  componentDidUpdate(prevProps) {
    const {
      inline: prevInline,
      remotes: prevRemotes,
    } = separateScripts(prevProps.code);
    const { inline, remotes } = separateScripts(this.props.code);
    if (!isEqual(prevRemotes.sort(), remotes.sort())) {
      remotes.forEach(src => injectRemoteScript(src));
    }
    if (prevInline !== inline) injectInlineScript(inline);
  }

  render() {
    const { code } = separateScripts(this.props.code);

    return (
      <CodeBacker {...this.props.attributes}>
        <CodeHeader textAlign='left'>
          <i className='fas fa-code' /> Code: inline
        </CodeHeader>
        <div
          dangerouslySetInnerHTML={{__html: code}}
        />
        <CodeHeader textAlign='right'>
          <i className='fas fa-code' />
        </CodeHeader>
      </CodeBacker>
    );
  }
}

export default Code;
